var map = {
	"./af-ZA/chat.json": [
		27619,
		27619
	],
	"./af-ZA/core.json": [
		65365,
		65365
	],
	"./af-ZA/entitlement_shop.json": [
		65508,
		65508
	],
	"./af-ZA/login.json": [
		48149,
		48149
	],
	"./af-ZA/profile.json": [
		5637,
		5637
	],
	"./af-ZA/shop.json": [
		66760,
		66760
	],
	"./af/chat.json": [
		75927,
		75927
	],
	"./af/core.json": [
		39860,
		39860
	],
	"./af/entitlement_shop.json": [
		56002,
		56002
	],
	"./af/login.json": [
		80717,
		80717
	],
	"./af/profile.json": [
		16528,
		16528
	],
	"./af/shop.json": [
		52640,
		52640
	],
	"./ar-SA/chat.json": [
		49952,
		49952
	],
	"./ar-SA/core.json": [
		16078,
		16078
	],
	"./ar-SA/entitlement_shop.json": [
		7457,
		7457
	],
	"./ar-SA/login.json": [
		12207,
		12207
	],
	"./ar-SA/profile.json": [
		23693,
		23693
	],
	"./ar-SA/shop.json": [
		63409,
		63409
	],
	"./ar/chat.json": [
		4347,
		4347
	],
	"./ar/core.json": [
		15154,
		15154
	],
	"./ar/entitlement_shop.json": [
		37608,
		37608
	],
	"./ar/login.json": [
		87856,
		87856
	],
	"./ar/profile.json": [
		54669,
		54669
	],
	"./ar/shop.json": [
		72520,
		72520
	],
	"./be-BY/chat.json": [
		24835,
		24835
	],
	"./be-BY/core.json": [
		25214,
		25214
	],
	"./be-BY/entitlement_shop.json": [
		8593,
		8593
	],
	"./be-BY/login.json": [
		55115,
		55115
	],
	"./be-BY/profile.json": [
		5316,
		5316
	],
	"./be-BY/shop.json": [
		41185,
		41185
	],
	"./be/chat.json": [
		11022,
		11022
	],
	"./be/core.json": [
		35114,
		35114
	],
	"./be/entitlement_shop.json": [
		39499,
		39499
	],
	"./be/login.json": [
		78422,
		78422
	],
	"./be/profile.json": [
		36537,
		36537
	],
	"./be/shop.json": [
		23581,
		23581
	],
	"./bg-BG/chat.json": [
		70181,
		70181
	],
	"./bg-BG/core.json": [
		79861,
		79861
	],
	"./bg-BG/entitlement_shop.json": [
		33566,
		33566
	],
	"./bg-BG/login.json": [
		54157,
		54157
	],
	"./bg-BG/profile.json": [
		93227,
		93227
	],
	"./bg-BG/shop.json": [
		2775,
		2775
	],
	"./bg/chat.json": [
		27810,
		27810
	],
	"./bg/core.json": [
		42850,
		42850
	],
	"./bg/entitlement_shop.json": [
		3203,
		3203
	],
	"./bg/login.json": [
		81100,
		81100
	],
	"./bg/profile.json": [
		8302,
		8302
	],
	"./bg/shop.json": [
		80058,
		80058
	],
	"./cs-CZ/chat.json": [
		70662,
		70662
	],
	"./cs-CZ/core.json": [
		77549,
		77549
	],
	"./cs-CZ/entitlement_shop.json": [
		85328,
		85328
	],
	"./cs-CZ/login.json": [
		17721,
		17721
	],
	"./cs-CZ/profile.json": [
		53104,
		53104
	],
	"./cs-CZ/shop.json": [
		47645,
		47645
	],
	"./cs/chat.json": [
		34854,
		34854
	],
	"./cs/core.json": [
		19063,
		19063
	],
	"./cs/entitlement_shop.json": [
		86591,
		86591
	],
	"./cs/login.json": [
		54603,
		54603
	],
	"./cs/profile.json": [
		20098,
		20098
	],
	"./cs/shop.json": [
		99763,
		99763
	],
	"./da-DK/chat.json": [
		91560,
		91560
	],
	"./da-DK/core.json": [
		55100,
		55100
	],
	"./da-DK/entitlement_shop.json": [
		92657,
		92657
	],
	"./da-DK/login.json": [
		97904,
		97904
	],
	"./da-DK/profile.json": [
		30703,
		30703
	],
	"./da-DK/shop.json": [
		95534,
		95534
	],
	"./da/chat.json": [
		69466,
		69466
	],
	"./da/core.json": [
		84538,
		84538
	],
	"./da/entitlement_shop.json": [
		39357,
		39357
	],
	"./da/login.json": [
		20116,
		20116
	],
	"./da/profile.json": [
		60014,
		60014
	],
	"./da/shop.json": [
		92825,
		92825
	],
	"./de-DE/chat.json": [
		40863,
		40863
	],
	"./de-DE/core.json": [
		45858,
		45858
	],
	"./de-DE/entitlement_shop.json": [
		82548,
		82548
	],
	"./de-DE/login.json": [
		27034,
		27034
	],
	"./de-DE/profile.json": [
		34097,
		34097
	],
	"./de-DE/shop.json": [
		52350,
		52350
	],
	"./de/chat.json": [
		7071,
		7071
	],
	"./de/core.json": [
		63106,
		63106
	],
	"./de/entitlement_shop.json": [
		3702,
		3702
	],
	"./de/login.json": [
		34536,
		34536
	],
	"./de/profile.json": [
		13345,
		13345
	],
	"./de/shop.json": [
		95790,
		95790
	],
	"./el-GR/chat.json": [
		98118,
		98118
	],
	"./el-GR/core.json": [
		41735,
		41735
	],
	"./el-GR/entitlement_shop.json": [
		44695,
		44695
	],
	"./el-GR/login.json": [
		62699,
		62699
	],
	"./el-GR/profile.json": [
		81266,
		81266
	],
	"./el-GR/shop.json": [
		73644,
		73644
	],
	"./el/chat.json": [
		31938,
		31938
	],
	"./el/core.json": [
		90396,
		90396
	],
	"./el/entitlement_shop.json": [
		64787,
		64787
	],
	"./el/login.json": [
		53649,
		53649
	],
	"./el/profile.json": [
		18168,
		18168
	],
	"./el/shop.json": [
		94300,
		94300
	],
	"./en-CA/chat.json": [
		15337,
		15337
	],
	"./en-CA/core.json": [
		32951,
		32951
	],
	"./en-CA/entitlement_shop.json": [
		1174,
		1174
	],
	"./en-CA/login.json": [
		39715,
		39715
	],
	"./en-CA/profile.json": [
		26172,
		26172
	],
	"./en-CA/shop.json": [
		13877,
		13877
	],
	"./en-GB/chat.json": [
		97846,
		97846
	],
	"./en-GB/core.json": [
		6423,
		6423
	],
	"./en-GB/entitlement_shop.json": [
		58440,
		58440
	],
	"./en-GB/login.json": [
		53043,
		53043
	],
	"./en-GB/profile.json": [
		74313,
		74313
	],
	"./en-GB/shop.json": [
		83388,
		83388
	],
	"./en/chat.json": [
		48090,
		48090
	],
	"./en/core.json": [
		63766,
		63766
	],
	"./en/entitlement_shop.json": [
		13677,
		13677
	],
	"./en/login.json": [
		78557,
		78557
	],
	"./en/profile.json": [
		31303,
		31303
	],
	"./en/shop.json": [
		13202,
		13202
	],
	"./es-ES/chat.json": [
		5382,
		5382
	],
	"./es-ES/core.json": [
		62596,
		62596
	],
	"./es-ES/entitlement_shop.json": [
		95320,
		95320
	],
	"./es-ES/login.json": [
		65348,
		65348
	],
	"./es-ES/profile.json": [
		39925,
		39925
	],
	"./es-ES/shop.json": [
		16516,
		16516
	],
	"./es-MX/chat.json": [
		9933,
		9933
	],
	"./es-MX/core.json": [
		52329,
		52329
	],
	"./es-MX/entitlement_shop.json": [
		75186,
		75186
	],
	"./es-MX/login.json": [
		18315,
		18315
	],
	"./es-MX/profile.json": [
		9331,
		9331
	],
	"./es-MX/shop.json": [
		90121,
		90121
	],
	"./es/chat.json": [
		97384,
		97384
	],
	"./es/core.json": [
		47037,
		47037
	],
	"./es/entitlement_shop.json": [
		94401,
		94401
	],
	"./es/login.json": [
		56838,
		56838
	],
	"./es/profile.json": [
		2892,
		2892
	],
	"./es/shop.json": [
		856,
		856
	],
	"./fa-IR/chat.json": [
		80009,
		80009
	],
	"./fa-IR/core.json": [
		33636,
		33636
	],
	"./fa-IR/entitlement_shop.json": [
		13013,
		13013
	],
	"./fa-IR/login.json": [
		50163,
		50163
	],
	"./fa-IR/profile.json": [
		68573,
		68573
	],
	"./fa-IR/shop.json": [
		55358,
		55358
	],
	"./fa/chat.json": [
		46328,
		46328
	],
	"./fa/core.json": [
		45752,
		45752
	],
	"./fa/entitlement_shop.json": [
		62302,
		62302
	],
	"./fa/login.json": [
		13529,
		13529
	],
	"./fa/profile.json": [
		86918,
		86918
	],
	"./fa/shop.json": [
		45871,
		45871
	],
	"./fi-FI/chat.json": [
		40719,
		40719
	],
	"./fi-FI/core.json": [
		43271,
		43271
	],
	"./fi-FI/entitlement_shop.json": [
		62663,
		62663
	],
	"./fi-FI/login.json": [
		51556,
		51556
	],
	"./fi-FI/profile.json": [
		38054,
		38054
	],
	"./fi-FI/shop.json": [
		37342,
		37342
	],
	"./fi/chat.json": [
		5255,
		5255
	],
	"./fi/core.json": [
		7320,
		7320
	],
	"./fi/entitlement_shop.json": [
		37890,
		37890
	],
	"./fi/login.json": [
		23361,
		23361
	],
	"./fi/profile.json": [
		57662,
		57662
	],
	"./fi/shop.json": [
		83074,
		83074
	],
	"./fil-PH/chat.json": [
		95498,
		95498
	],
	"./fil-PH/core.json": [
		21003,
		21003
	],
	"./fil-PH/entitlement_shop.json": [
		47527,
		47527
	],
	"./fil-PH/login.json": [
		51400,
		51400
	],
	"./fil-PH/profile.json": [
		52325,
		7325
	],
	"./fil-PH/shop.json": [
		85487,
		85487
	],
	"./fil/chat.json": [
		91699,
		91699
	],
	"./fil/core.json": [
		36801,
		36801
	],
	"./fil/entitlement_shop.json": [
		96148,
		96148
	],
	"./fil/login.json": [
		28236,
		28236
	],
	"./fil/profile.json": [
		35786,
		35786
	],
	"./fil/shop.json": [
		72190,
		72190
	],
	"./fr-CA/chat.json": [
		68965,
		68965
	],
	"./fr-CA/core.json": [
		82016,
		82016
	],
	"./fr-CA/entitlement_shop.json": [
		41591,
		41591
	],
	"./fr-CA/login.json": [
		2670,
		2670
	],
	"./fr-CA/profile.json": [
		16293,
		16293
	],
	"./fr-CA/shop.json": [
		43908,
		43908
	],
	"./fr-FR/chat.json": [
		21973,
		21973
	],
	"./fr-FR/core.json": [
		27977,
		27977
	],
	"./fr-FR/entitlement_shop.json": [
		78726,
		78726
	],
	"./fr-FR/login.json": [
		27831,
		27831
	],
	"./fr-FR/profile.json": [
		1743,
		1743
	],
	"./fr-FR/shop.json": [
		1658,
		1658
	],
	"./fr/chat.json": [
		49561,
		49561
	],
	"./fr/core.json": [
		69900,
		69900
	],
	"./fr/entitlement_shop.json": [
		207,
		207
	],
	"./fr/login.json": [
		29226,
		29226
	],
	"./fr/profile.json": [
		9379,
		9379
	],
	"./fr/shop.json": [
		91967,
		91967
	],
	"./he-IL/chat.json": [
		99412,
		99412
	],
	"./he-IL/core.json": [
		28355,
		28355
	],
	"./he-IL/entitlement_shop.json": [
		19209,
		19209
	],
	"./he-IL/login.json": [
		2857,
		2857
	],
	"./he-IL/profile.json": [
		74592,
		74592
	],
	"./he-IL/shop.json": [
		48609,
		48609
	],
	"./he/chat.json": [
		91200,
		91200
	],
	"./he/core.json": [
		77305,
		77305
	],
	"./he/entitlement_shop.json": [
		64372,
		64372
	],
	"./he/login.json": [
		66075,
		66075
	],
	"./he/profile.json": [
		19003,
		19003
	],
	"./he/shop.json": [
		10733,
		10733
	],
	"./hi-IN/chat.json": [
		821,
		821
	],
	"./hi-IN/core.json": [
		87570,
		87570
	],
	"./hi-IN/entitlement_shop.json": [
		8444,
		8444
	],
	"./hi-IN/login.json": [
		24813,
		24813
	],
	"./hi-IN/profile.json": [
		16400,
		16400
	],
	"./hi-IN/shop.json": [
		48771,
		48771
	],
	"./hi/chat.json": [
		93442,
		93442
	],
	"./hi/core.json": [
		3227,
		3227
	],
	"./hi/entitlement_shop.json": [
		44854,
		44854
	],
	"./hi/login.json": [
		17847,
		17847
	],
	"./hi/profile.json": [
		53252,
		53252
	],
	"./hi/shop.json": [
		12405,
		12405
	],
	"./hu-HU/chat.json": [
		52594,
		52594
	],
	"./hu-HU/core.json": [
		75551,
		69601
	],
	"./hu-HU/entitlement_shop.json": [
		12965,
		12965
	],
	"./hu-HU/login.json": [
		72141,
		72141
	],
	"./hu-HU/profile.json": [
		47801,
		47801
	],
	"./hu-HU/shop.json": [
		16397,
		16397
	],
	"./hu/chat.json": [
		67643,
		67643
	],
	"./hu/core.json": [
		17030,
		17030
	],
	"./hu/entitlement_shop.json": [
		81969,
		81969
	],
	"./hu/login.json": [
		24631,
		24631
	],
	"./hu/profile.json": [
		41131,
		41131
	],
	"./hu/shop.json": [
		9032,
		9032
	],
	"./id-ID/chat.json": [
		81059,
		81059
	],
	"./id-ID/core.json": [
		25895,
		25895
	],
	"./id-ID/entitlement_shop.json": [
		9746,
		9746
	],
	"./id-ID/login.json": [
		94341,
		68989
	],
	"./id-ID/profile.json": [
		57682,
		57682
	],
	"./id-ID/shop.json": [
		60973,
		60973
	],
	"./id/chat.json": [
		58546,
		58546
	],
	"./id/core.json": [
		28804,
		28804
	],
	"./id/entitlement_shop.json": [
		42582,
		42582
	],
	"./id/login.json": [
		1256,
		1256
	],
	"./id/profile.json": [
		11273,
		11273
	],
	"./id/shop.json": [
		68994,
		68994
	],
	"./it-IT/chat.json": [
		48650,
		48650
	],
	"./it-IT/core.json": [
		67536,
		67536
	],
	"./it-IT/entitlement_shop.json": [
		27224,
		27224
	],
	"./it-IT/login.json": [
		95701,
		95701
	],
	"./it-IT/profile.json": [
		88003,
		88003
	],
	"./it-IT/shop.json": [
		22967,
		22967
	],
	"./it/chat.json": [
		50569,
		50569
	],
	"./it/core.json": [
		25757,
		25757
	],
	"./it/entitlement_shop.json": [
		44539,
		44539
	],
	"./it/login.json": [
		44011,
		44011
	],
	"./it/profile.json": [
		46937,
		46937
	],
	"./it/shop.json": [
		49049,
		49049
	],
	"./ja-JP/chat.json": [
		15603,
		15603
	],
	"./ja-JP/core.json": [
		59977,
		59977
	],
	"./ja-JP/entitlement_shop.json": [
		95175,
		95175
	],
	"./ja-JP/login.json": [
		27575,
		27575
	],
	"./ja-JP/profile.json": [
		27919,
		27919
	],
	"./ja-JP/shop.json": [
		14276,
		14276
	],
	"./ja/chat.json": [
		15071,
		15071
	],
	"./ja/core.json": [
		28062,
		28062
	],
	"./ja/entitlement_shop.json": [
		45435,
		45435
	],
	"./ja/login.json": [
		89001,
		89001
	],
	"./ja/profile.json": [
		18106,
		18106
	],
	"./ja/shop.json": [
		27082,
		27082
	],
	"./ko-KR/chat.json": [
		84667,
		84667
	],
	"./ko-KR/core.json": [
		22851,
		22851
	],
	"./ko-KR/entitlement_shop.json": [
		87008,
		87008
	],
	"./ko-KR/login.json": [
		82430,
		82430
	],
	"./ko-KR/profile.json": [
		58220,
		58220
	],
	"./ko-KR/shop.json": [
		53860,
		53860
	],
	"./ko/chat.json": [
		79607,
		79607
	],
	"./ko/core.json": [
		5177,
		5177
	],
	"./ko/entitlement_shop.json": [
		60685,
		60685
	],
	"./ko/login.json": [
		96339,
		96339
	],
	"./ko/profile.json": [
		47426,
		47426
	],
	"./ko/shop.json": [
		89727,
		89727
	],
	"./ky-KG/chat.json": [
		89894,
		89894
	],
	"./ky-KG/core.json": [
		44901,
		44901
	],
	"./ky-KG/entitlement_shop.json": [
		77326,
		77326
	],
	"./ky-KG/login.json": [
		88208,
		88208
	],
	"./ky-KG/profile.json": [
		36151,
		36151
	],
	"./ky-KG/shop.json": [
		64614,
		64614
	],
	"./ky/chat.json": [
		48438,
		48438
	],
	"./ky/core.json": [
		91130,
		91130
	],
	"./ky/entitlement_shop.json": [
		64714,
		64714
	],
	"./ky/login.json": [
		63035,
		63035
	],
	"./ky/profile.json": [
		81260,
		81260
	],
	"./ky/shop.json": [
		31032,
		31032
	],
	"./lt-LT/chat.json": [
		51818,
		51818
	],
	"./lt-LT/core.json": [
		30751,
		30751
	],
	"./lt-LT/entitlement_shop.json": [
		93472,
		93472
	],
	"./lt-LT/login.json": [
		30058,
		30058
	],
	"./lt-LT/profile.json": [
		55039,
		55039
	],
	"./lt-LT/shop.json": [
		9589,
		9589
	],
	"./lt/chat.json": [
		2978,
		2978
	],
	"./lt/core.json": [
		93123,
		93123
	],
	"./lt/entitlement_shop.json": [
		56133,
		56133
	],
	"./lt/login.json": [
		56762,
		56762
	],
	"./lt/profile.json": [
		35333,
		35333
	],
	"./lt/shop.json": [
		48449,
		48449
	],
	"./ms-MY/chat.json": [
		26792,
		26792
	],
	"./ms-MY/core.json": [
		71805,
		71805
	],
	"./ms-MY/entitlement_shop.json": [
		66838,
		66838
	],
	"./ms-MY/login.json": [
		73532,
		73532
	],
	"./ms-MY/profile.json": [
		69206,
		69206
	],
	"./ms-MY/shop.json": [
		68758,
		68758
	],
	"./ms/chat.json": [
		94592,
		94592
	],
	"./ms/core.json": [
		66686,
		66686
	],
	"./ms/entitlement_shop.json": [
		80542,
		80542
	],
	"./ms/login.json": [
		77678,
		77678
	],
	"./ms/profile.json": [
		15440,
		15440
	],
	"./ms/shop.json": [
		7417,
		7417
	],
	"./nl-NL/chat.json": [
		62307,
		62307
	],
	"./nl-NL/core.json": [
		51468,
		51468
	],
	"./nl-NL/entitlement_shop.json": [
		16592,
		16592
	],
	"./nl-NL/login.json": [
		32078,
		32078
	],
	"./nl-NL/profile.json": [
		51207,
		51207
	],
	"./nl-NL/shop.json": [
		80941,
		80941
	],
	"./nl/chat.json": [
		77899,
		77899
	],
	"./nl/core.json": [
		25074,
		25074
	],
	"./nl/entitlement_shop.json": [
		27668,
		27668
	],
	"./nl/login.json": [
		75440,
		75440
	],
	"./nl/profile.json": [
		42218,
		42218
	],
	"./nl/shop.json": [
		94177,
		94177
	],
	"./no-NO/chat.json": [
		35650,
		35650
	],
	"./no-NO/core.json": [
		66541,
		66541
	],
	"./no-NO/entitlement_shop.json": [
		21282,
		21282
	],
	"./no-NO/login.json": [
		96576,
		96576
	],
	"./no-NO/profile.json": [
		68181,
		68181
	],
	"./no-NO/shop.json": [
		35097,
		35097
	],
	"./no/chat.json": [
		35750,
		35750
	],
	"./no/core.json": [
		34957,
		34957
	],
	"./no/entitlement_shop.json": [
		26016,
		26016
	],
	"./no/login.json": [
		62978,
		62978
	],
	"./no/profile.json": [
		4810,
		4810
	],
	"./no/shop.json": [
		62061,
		62061
	],
	"./pl-PL/chat.json": [
		91559,
		91559
	],
	"./pl-PL/core.json": [
		54806,
		54806
	],
	"./pl-PL/entitlement_shop.json": [
		96562,
		96562
	],
	"./pl-PL/login.json": [
		71990,
		71990
	],
	"./pl-PL/profile.json": [
		19836,
		19836
	],
	"./pl-PL/shop.json": [
		90433,
		90433
	],
	"./pl/chat.json": [
		75705,
		75705
	],
	"./pl/core.json": [
		21075,
		21075
	],
	"./pl/entitlement_shop.json": [
		58273,
		58273
	],
	"./pl/login.json": [
		9856,
		9856
	],
	"./pl/profile.json": [
		46318,
		46318
	],
	"./pl/shop.json": [
		91916,
		91916
	],
	"./pt-BR/chat.json": [
		90159,
		90159
	],
	"./pt-BR/core.json": [
		12502,
		12502
	],
	"./pt-BR/entitlement_shop.json": [
		67028,
		67028
	],
	"./pt-BR/login.json": [
		68483,
		68483
	],
	"./pt-BR/profile.json": [
		89307,
		89307
	],
	"./pt-BR/shop.json": [
		65671,
		65671
	],
	"./pt-PT/chat.json": [
		8714,
		8714
	],
	"./pt-PT/core.json": [
		35519,
		35519
	],
	"./pt-PT/entitlement_shop.json": [
		56953,
		56953
	],
	"./pt-PT/login.json": [
		96117,
		96117
	],
	"./pt-PT/profile.json": [
		49292,
		49292
	],
	"./pt-PT/shop.json": [
		56761,
		56761
	],
	"./pt/chat.json": [
		6444,
		6444
	],
	"./pt/core.json": [
		87104,
		87104
	],
	"./pt/entitlement_shop.json": [
		56458,
		56458
	],
	"./pt/login.json": [
		59289,
		59289
	],
	"./pt/profile.json": [
		42362,
		42362
	],
	"./pt/shop.json": [
		26618,
		26618
	],
	"./ro-RO/chat.json": [
		54574,
		54574
	],
	"./ro-RO/core.json": [
		79595,
		79595
	],
	"./ro-RO/entitlement_shop.json": [
		82736,
		82736
	],
	"./ro-RO/login.json": [
		16973,
		16973
	],
	"./ro-RO/profile.json": [
		19590,
		19590
	],
	"./ro-RO/shop.json": [
		46296,
		46296
	],
	"./ro/chat.json": [
		70828,
		70828
	],
	"./ro/core.json": [
		50887,
		50887
	],
	"./ro/entitlement_shop.json": [
		59358,
		59358
	],
	"./ro/login.json": [
		89795,
		89795
	],
	"./ro/profile.json": [
		7851,
		7851
	],
	"./ro/shop.json": [
		98723,
		98723
	],
	"./ru-RU/chat.json": [
		306,
		306
	],
	"./ru-RU/core.json": [
		43979,
		43979
	],
	"./ru-RU/entitlement_shop.json": [
		96424,
		96424
	],
	"./ru-RU/login.json": [
		18630,
		52325
	],
	"./ru-RU/profile.json": [
		7199,
		7199
	],
	"./ru-RU/shop.json": [
		4178,
		4178
	],
	"./ru/chat.json": [
		65913,
		65913
	],
	"./ru/core.json": [
		50812,
		50812
	],
	"./ru/entitlement_shop.json": [
		12373,
		12373
	],
	"./ru/login.json": [
		40294,
		40294
	],
	"./ru/profile.json": [
		29314,
		29314
	],
	"./ru/shop.json": [
		5678,
		5678
	],
	"./sk-SK/chat.json": [
		45748,
		45748
	],
	"./sk-SK/core.json": [
		74814,
		74814
	],
	"./sk-SK/entitlement_shop.json": [
		6104,
		6104
	],
	"./sk-SK/login.json": [
		63341,
		63341
	],
	"./sk-SK/profile.json": [
		68225,
		68225
	],
	"./sk-SK/shop.json": [
		97859,
		97859
	],
	"./sk/chat.json": [
		24438,
		24438
	],
	"./sk/core.json": [
		33137,
		33137
	],
	"./sk/entitlement_shop.json": [
		35656,
		35656
	],
	"./sk/login.json": [
		62847,
		62847
	],
	"./sk/profile.json": [
		84385,
		84385
	],
	"./sk/shop.json": [
		46323,
		46323
	],
	"./sv-SE/chat.json": [
		97295,
		97295
	],
	"./sv-SE/core.json": [
		12930,
		12930
	],
	"./sv-SE/entitlement_shop.json": [
		82846,
		82846
	],
	"./sv-SE/login.json": [
		67723,
		67723
	],
	"./sv-SE/profile.json": [
		73775,
		73775
	],
	"./sv-SE/shop.json": [
		7461,
		7461
	],
	"./sv/chat.json": [
		86004,
		86004
	],
	"./sv/core.json": [
		59757,
		59757
	],
	"./sv/entitlement_shop.json": [
		87161,
		87161
	],
	"./sv/login.json": [
		14312,
		14312
	],
	"./sv/profile.json": [
		96612,
		96612
	],
	"./sv/shop.json": [
		85638,
		85638
	],
	"./th-TH/chat.json": [
		34135,
		34135
	],
	"./th-TH/core.json": [
		3176,
		3176
	],
	"./th-TH/entitlement_shop.json": [
		8327,
		8327
	],
	"./th-TH/login.json": [
		14364,
		14364
	],
	"./th-TH/profile.json": [
		51647,
		51647
	],
	"./th-TH/shop.json": [
		32000,
		32000
	],
	"./th/chat.json": [
		68321,
		68321
	],
	"./th/core.json": [
		19051,
		19051
	],
	"./th/entitlement_shop.json": [
		91454,
		91454
	],
	"./th/login.json": [
		97553,
		97553
	],
	"./th/profile.json": [
		48157,
		48157
	],
	"./th/shop.json": [
		3448,
		3448
	],
	"./tr-TR/chat.json": [
		44135,
		44135
	],
	"./tr-TR/core.json": [
		76159,
		76159
	],
	"./tr-TR/entitlement_shop.json": [
		95307,
		95307
	],
	"./tr-TR/login.json": [
		23114,
		23114
	],
	"./tr-TR/profile.json": [
		70272,
		70272
	],
	"./tr-TR/shop.json": [
		17928,
		17928
	],
	"./tr/chat.json": [
		21826,
		21826
	],
	"./tr/core.json": [
		19734,
		19734
	],
	"./tr/entitlement_shop.json": [
		74412,
		74412
	],
	"./tr/login.json": [
		12290,
		12290
	],
	"./tr/profile.json": [
		45634,
		45634
	],
	"./tr/shop.json": [
		22156,
		22156
	],
	"./uk-UA/chat.json": [
		79882,
		79882
	],
	"./uk-UA/core.json": [
		76083,
		76083
	],
	"./uk-UA/entitlement_shop.json": [
		52288,
		52288
	],
	"./uk-UA/login.json": [
		4479,
		74402
	],
	"./uk-UA/profile.json": [
		24808,
		24808
	],
	"./uk-UA/shop.json": [
		77103,
		77103
	],
	"./uk/chat.json": [
		69129,
		69129
	],
	"./uk/core.json": [
		92862,
		92862
	],
	"./uk/entitlement_shop.json": [
		21753,
		21753
	],
	"./uk/login.json": [
		51107,
		51107
	],
	"./uk/profile.json": [
		31628,
		31628
	],
	"./uk/shop.json": [
		98509,
		98509
	],
	"./vi-VN/chat.json": [
		94202,
		94202
	],
	"./vi-VN/core.json": [
		82001,
		82001
	],
	"./vi-VN/entitlement_shop.json": [
		12194,
		12194
	],
	"./vi-VN/login.json": [
		66083,
		66083
	],
	"./vi-VN/profile.json": [
		26047,
		26047
	],
	"./vi-VN/shop.json": [
		23524,
		23524
	],
	"./vi/chat.json": [
		76761,
		76761
	],
	"./vi/core.json": [
		81694,
		81694
	],
	"./vi/entitlement_shop.json": [
		80140,
		80140
	],
	"./vi/login.json": [
		36648,
		36648
	],
	"./vi/profile.json": [
		87920,
		87920
	],
	"./vi/shop.json": [
		44902,
		44902
	],
	"./zh-CN/chat.json": [
		43759,
		43759
	],
	"./zh-CN/core.json": [
		68793,
		68793
	],
	"./zh-CN/entitlement_shop.json": [
		51521,
		51521
	],
	"./zh-CN/login.json": [
		77898,
		77898
	],
	"./zh-CN/profile.json": [
		85851,
		85851
	],
	"./zh-CN/shop.json": [
		72952,
		72952
	],
	"./zh-TW/chat.json": [
		29031,
		29031
	],
	"./zh-TW/core.json": [
		4079,
		4079
	],
	"./zh-TW/entitlement_shop.json": [
		20314,
		20314
	],
	"./zh-TW/login.json": [
		64438,
		64438
	],
	"./zh-TW/profile.json": [
		93647,
		93647
	],
	"./zh-TW/shop.json": [
		7403,
		7403
	],
	"./zh/chat.json": [
		85579,
		85579
	],
	"./zh/core.json": [
		92445,
		92445
	],
	"./zh/entitlement_shop.json": [
		97513,
		97513
	],
	"./zh/login.json": [
		95201,
		95201
	],
	"./zh/profile.json": [
		71073,
		71073
	],
	"./zh/shop.json": [
		3336,
		3336
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 36463;
module.exports = webpackAsyncContext;